<template>
  <div>
    <div class="order-info">
      <el-checkbox
        :disabled="info.applyType === '04'"
        v-if="type !== 'all' && showBatchApproval"
        class="check-box"
        v-model="info.checked"
        @change="infoCheck"
      ></el-checkbox>

      <el-card shadow="hover" class="cursor" @click.native="handleDetail">
        <el-row>
          <el-col :span="4">
            <img v-if="info.applyType === '02'" src="../../../assets/images/materials@2x.png" />
            <img v-else-if="info.applyType === '04'" :src="info.circlePocImage ? info.circlePocImage : require('../../../assets/images/pbo.png')" />
            <img v-else :src="orderImg === 'default' ? require('../../../assets/images/poc_photo_default.png') : orderImg" />
            <div class="trade-date">{{ info.applyDate | parseTime('{y}-{m}-{d}') }}</div>
          </el-col>
          <el-col :span="9">
            <div class="trade-store-name margin-top-15" v-if="info.applyType == '02'">{{ info.eventSubject }}</div>
            <div class="trade-store-name margin-top-15" v-else-if="info.applyType === '04'">{{ info.circlePocName }}</div>
            <div class="trade-store-name margin-top-15" v-else>{{ pocName }}</div>
            <div class="margin-top-15">{{ info.applyClientLevelName }}-{{ info.applyClientName }}</div>
            <div class="margin-top-15" style="font-size:12px" v-if="info.basePocDTO && info.execList.length && centerOrderList.includes(info.execList[0].execTypeSub)">{{ info.basePocDTO.abiPocStatusName }}</div>
            <template v-for="(tItem, index) in typeList">
              <el-button size="small" class="btn-grey-plain btn margin-top-15" style="cursor: auto" :key="index">{{ tItem }}</el-button>
            </template>
          </el-col>
          <el-col :span="11" style="text-align: right">
            <el-row>
              <div class="margin-bottom-10" style="color: #c8102d; font-weight: bold">{{ orderStatus }}</div>
            </el-row>
            <el-row>
              <div class="margin-bottom-10 trade-store-number">
                {{ info.applyNumber }}
                <img v-if="extendImgShow" src="../../../assets/images/extend-box.png" />
              </div>
            </el-row>
            <el-row>
              <el-col class="margin-bottom-10" :span="12" v-show="info.quoteAmount">报价金额：{{ (info.quoteAmount || '') | thousandSymbol }}元</el-col>
              <el-col class="margin-bottom-10" :span="12" v-show="info.actualAmount">实际金额：{{ (info.actualAmount || '') | thousandSymbol }}元</el-col>
            </el-row>
            <el-row>
              <div class="margin-bottom-10" v-if="info.applyType === '04'">{{ info.circlePocAddress }}</div>
              <div class="margin-bottom-10" v-else>{{ pocAddress }}</div>
            </el-row>
            <el-row>
              <el-button class="btn-blue-plain" size="small" v-if="type === 'waitCheck'" @click.stop="handleClick('03', info.applyId, info.applyType)"
                >驳回</el-button
              >
              <el-button
                class="btn-red"
                size="small"
                v-if="type === 'waitCheck' || type === 'waitAccept'"
                @click.stop="handleClick('02', info.applyId, info.applyType)"
                >{{ confirmText(type) }}</el-button
              >
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { commonUtils } from '@/utils/common'
export default {
  props: ['info', 'type', 'showBatchApproval'],
  data () {
    return {
      typeList: [],
      checked: false,
      centerOrderList: ['102', '105', '111', '112', '113', '201', '202', '302', '303']
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    extendImgShow () {
      if (this.info) {
        if (this.info.execList?.length) {
          return this.info.mainApplyId && !this.info.execList[0].execCoolerList
        }
      }
      return false
    },
    orderStatus () {
      if (this.info?.execList?.length) {
        const { execTypeSub } = this.info.execList[0]
        const { isStack } = this.info
        if (execTypeSub === '121') {
          if (isStack === '0') {
            return '已禁用'
          } else {
            return '执行中'
          }
        } else {
          return this.info.applyStatusName
        }
      }
      return ''
    },

    orderImg () {
      const { execList, pocOutsidePhotoUri } = this.info
      if (execList?.length) {
        if (['111', '112', '113'].includes(execList[0].execTypeSub)) {
          return this.getImageUrl(execList[0]?.tradeApplyExecCoolerTrackDTO?.itemImageInfo?.imageFileUri)
        }
      }
      if (this.centerOrderList.includes(execList[0].execTypeSub)) {
        if (this.info.abiValidationStatus == 0 && this.info.abiValidationType == 3) {
          return 'default'
        } else {
          return this.getImageUrl(pocOutsidePhotoUri)
        }
      }
      return this.getImageUrl(pocOutsidePhotoUri)
    },

    pocName () {
      const { execList, pocName } = this.info
      if (execList?.length) {
        if (['111', '112', '113'].includes(execList[0].execTypeSub)) {
          return execList[0].tradeApplyExecCoolerTrackDTO.coolerItemName
        }
      }
      return pocName
    },

    pocAddress () {
      const { execList, provinceName, cityName, countyName, detailAddress } = this.info
      if (execList?.length) {
        if (['111', '112', '113'].includes(execList[0].execTypeSub)) {
          const { beforePocInfo = false, wholesalerInfo = false, afterPocInfo = false } = execList[0].tradeApplyExecCoolerTrackDTO
          if (beforePocInfo || wholesalerInfo || afterPocInfo) {
            if (execList[0].execTypeSub === '112') {
              return `${beforePocInfo.pocName} => ${wholesalerInfo ? wholesalerInfo.wholesalerName : '暂无'}`
            } else if (execList[0].execTypeSub === '113') {
              return `${wholesalerInfo ? wholesalerInfo.wholesalerName : '暂无'} => ${afterPocInfo.pocName}`
            }
            return `${beforePocInfo.pocName} => ${afterPocInfo.pocName}`
          }
        }
      }
      return `${provinceName || ''}${cityName || ''}${countyName || ''}${detailAddress || ''}`
    },

    showPocAddress () {
      return this.info.applyType !== '04' && this.info?.execList?.length && !['111', '112', '113'].includes(this.info?.execList[0]?.execTypeSub)
    }
  },
  watch: {
    info: {
      immediate: true,
      deep: true,
      handler () {
        this.getOrderType(this.info)
      }
    }
  },
  methods: {
    getImageUrl (url) {
      return commonUtils.getImageUrl(url)
    },

    confirmText (type) {
      if (type === 'waitCheck') {
        return '确认验收'
      }
      if (type === 'waitAccept') {
        return '去收货'
      }
    },

    // 获取订单类型
    getOrderType (info) {
      let typeList = []
      if (info.applyType === '02') {
        typeList.push('批量化物料')
        this.typeList = typeList
        return
      }
      info.execList.forEach((item) => {
        typeList.push(this.setTypeText(item.execTypeSub))
      })
      this.typeList = typeList
    },

    // 订单类型
    setTypeText (val) {
      const typeObj = {
        '101': '高端店招',
        '102': '资产冰柜',
        '103': '完美门店',
        '104': 'PBO计划',
        '105': '完美门店',
        '106': 'PBO',
        '107': '能量包',
        '108': '夏季能量包',
        '109': '青柠大行动',
        '201': '门店定制',
        '202': 'Star店招计划',
        '301': 'ISP高端执行',
        '302': 'ISP形象店',
        '303': 'ISP物料定制',
        '305': 'ISP超高端',
        '111': '冰柜转店',
        '112': '冰柜回库',
        '113': '冰柜再投放',
        '121': '一元换购',
      }
      return typeObj[val] || ''
    },

    infoCheck (val) {
      this.$emit('infoCheck')
    },

    handleClick (val, id, applyType) {
      let data = {
        type: val,
        applyId: id,
        applyType: applyType,
        orderInfo: this.info
      }
      this.$emit('handleClick', data)
    },

    // 查看详情
    handleDetail () {
      let routerPath = '/trade/order-info'
      if (this.info.execList) {
        const { execTypeSub } = this.info.execList[0]
        if (['105', '106', '107', '108', '109'].includes(execTypeSub)) {
          routerPath = '/trade/perfect-order-info'
        }
        if (['111', '112', '113'].includes(execTypeSub)) {
          //return;    //暂时取消详情
          routerPath = '/trade/cooler-order-info'
        }
        if (execTypeSub === '121') {
          routerPath = '/trade/dcof-order-info'
        }
      }
      this.$router.push({
        path: routerPath,
        query: {
          applyId: this.info.applyId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-bottom-10 {
  margin-bottom: 10px;
}
.margin-top-15 {
  margin-top: 15px;
}
.order-info {
  position: relative;

  .el-card {
    border-radius: 8px;
  }
}
.check-box {
  position: absolute;
  top: 50%;
  left: -30px;
  transform: translateY(-50%);
  zoom: 140%;
}
.btn {
  height: 26px;
  padding: 0 15px;
  text-align: center;
  border-radius: 13px;
  line-height: 5px;
}
.batch-btn {
  margin-left: 45%;
  background-color: $base-white;
  color: $base-dark;
  border-color: $base-dark;
}
img,
.photo {
  width: 100px;
  height: 100px;
  border-radius: 6px;
  object-fit: cover;
}
.trade-date {
  width: 100px;
  color: #666666;
  font-size: 14px;
  text-align: center;
  padding-top: 5px;
}
.order-info .el-button {
  margin-left: 0px;
  margin-right: 10px;
}

.btn-grey-plain {
  color: #000 !important;
  border-color: #888;
}

.trade-store-name {
  font-size: 18px;
  font-weight: bold;
}
.trade-store-number {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  img {
    width: 20px;
    height: 20px;
    margin-left: 8px;
  }
}
</style>
